var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurePayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 45,
    viewBox: "0 0 54 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d4bc9e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.412,16.957a2.931,2.931,0,0,0-2.928-2.928h-4.2a2.931,2.931,0,0,0-2.928,2.928v3.673a2.931,2.931,0,0,0,2.928,2.928h4.2a2.931,2.931,0,0,0,2.928-2.928Zm-3.176,3.425H9.529V17.206h3.706Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.353,26.735h6.353v3.176H6.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.882,26.735h6.353v3.176H15.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.824,26.735V25a8.486,8.486,0,0,0-6.353-8.2V8.745A4.249,4.249,0,0,0,40.226,4.5H4.245A4.249,4.249,0,0,0,0,8.745V32.02a4.249,4.249,0,0,0,4.245,4.245H30.706v1.588a11.647,11.647,0,0,0,23.294,0V26.735ZM47.647,25v1.74H37.059V25a5.294,5.294,0,1,1,10.588,0Zm-43.4,8.092A1.069,1.069,0,0,1,3.176,32.02V8.745A1.069,1.069,0,0,1,4.245,7.676H40.226a1.069,1.069,0,0,1,1.068,1.068v7.849A8.481,8.481,0,0,0,33.882,25v1.739H25.412v3.176h5.294v3.176Zm46.579,4.765a8.471,8.471,0,1,1-16.941,0V29.912H50.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M41.237,41.63l6.414-5.773L45.526,33.5l-4.174,3.757-2.111-2.111-2.246,2.246Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePayment);
export default __webpack_public_path__ + "static/media/secure-payment.5b7b37eef37ca1b232d2bcef7097f498.svg";
export { ForwardRef as ReactComponent };